import { render, staticRenderFns } from "./ModalShutdownServer.vue?vue&type=template&id=782c5480"
import script from "./ModalShutdownServer.vue?vue&type=script&lang=js"
export * from "./ModalShutdownServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports